import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 md:py-14 bg-white" data-id="element-109">
      <div className="max-w-3xl mx-auto px-4" data-id="element-110">
        <div className="bg-solution/5 border-2 border-solution/30 rounded-2xl p-5 md:p-10 text-center" data-id="element-111">
          <ShieldCheckIcon className="w-16 h-16 mx-auto mb-4 text-solution" data-id="element-112" />

          <h2 className="font-heading text-2xl md:text-3xl font-bold text-dark mb-2" data-id="element-113">
            🛡️ 14-Day "Use It On Your Family" Guarantee
          </h2>

          <div className="text-dark leading-relaxed space-y-3 md:space-y-4 mt-4 text-left md:text-center" data-id="element-114">
            <p data-id="element-115">
              Here's our promise: download the handbook, use it the next time
              someone in your house gets sick, and see the difference for
              yourself.
            </p>

            <p data-id="element-116">
              If for any reason — <strong data-id="element-117">any reason at all</strong> — you don't
              feel like this is the most useful natural health resource you've
              ever had, email us within 14 days and we'll refund every single
              dollar.
            </p>

            <p className="font-medium text-primary" data-id="element-118">
              No forms. No questions. No drama.
            </p>

            <p className="text-lg font-bold" data-id="element-119">
              We're that confident you'll never want to give it back.
            </p>
          </div>
        </div>
      </div>
    </section>;
}